import React from 'react';

import ElixiaLetter from '@sats-group/icons/32/elixia';
import SatsLetter from '@sats-group/icons/32/sats';
import ElixiaLetterPride from '@sats-group/ui-lib/react/logos/elixia-letter-pride-dark';
import ElixiaFullPride from '@sats-group/ui-lib/react/logos/elixia-pride-dark';
import ElixiaFull from '@sats-group/ui-lib/react/logos/elixia-small';
import SatsLetterPride from '@sats-group/ui-lib/react/logos/sats-letter-pride-dark';
import SatsFullPride from '@sats-group/ui-lib/react/logos/sats-pride-dark';
import SatsFull from '@sats-group/ui-lib/react/logos/sats-small';

import type { Logo as Props } from './logo.props';
import { themes, variants } from './logo.props';

type Brand = 'sats' | 'elixia';
type Variant = keyof typeof variants;
type Theme = keyof typeof themes;

const logoComponents: Record<
  Brand,
  Record<Variant, Record<Theme, React.ComponentType>>
> = {
  sats: {
    full: { basic: SatsFull, pride: SatsFullPride },
    letter: { basic: SatsLetter, pride: SatsLetterPride },
  },
  elixia: {
    full: { basic: ElixiaFull, pride: ElixiaFullPride },
    letter: { basic: ElixiaLetter, pride: ElixiaLetterPride },
  },
};

const Logo: React.FunctionComponent<React.PropsWithChildren<Props>> & {
  themes: typeof themes;
  variants: typeof variants;
} = ({
  href,
  label,
  language,
  theme = themes.basic,
  variant = variants.full,
}) => {
  const brand: Brand = language === 'fi' ? 'elixia' : 'sats';
  const LogoComponent =
    logoComponents[brand][variant as Variant][theme as Theme];

  return href ? (
    <a href={href} aria-label={label} className="logo">
      <LogoComponent />
    </a>
  ) : (
    <span className="logo">
      <LogoComponent />
    </span>
  );
};

Logo.themes = themes;
Logo.variants = variants;

export default Logo;
